<template>
  <div>
    <div style="z-index: 998;position: absolute;display: inline-block;left: 50%;transform: translateX(-50%);top: 10%;">
      <img src="../assets/img/zlws_adv_agency.png" style="display: block;width: 226px;height: 71px;">
    </div>
    <div class="login_form">
      <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="login-container">
        <h3 class="title">专利<span style="color: #2dbdd0;">监控</span>平台</h3>
        <el-form-item prop="username">
          <el-input type="text" v-model="ruleForm.username" auto-complete="off" placeholder="账户" clearable=""></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" v-model="ruleForm.password" auto-complete="off" placeholder="密码" clearable=""></el-input>
        </el-form-item>
        <el-checkbox class="remember" v-model="rememberpwd">记住密码</el-checkbox>
        <el-form-item style="width:100%;">
          <el-button style="width:100%;background-color: #2dbdd0;color: #fff;" @click="submitForm('ruleForm')" :loading="logining">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- <div class="code_img"><img src=""></div> -->
    <div class="gongsi_name">
        <img src="../assets/img/fzg.png" class="wechat_code">
        <span>扫码体验微信小程序</span><br><br>
      <!-- <span>成都其知创新专利代理事务所</span>&nbsp;&nbsp; -->
      <!-- <span>Tel ：4000-666-289</span> -->
    </div>
    <particles></particles>
  </div>
</template>
<script type="text/ecmascript-6">
import { login } from '../api/userMG'
import { setCookie, getCookie, delCookie } from '../utils/util'
import particles from '../components/particles/index'
import md5 from 'js-md5'
export default {
  name: 'login',
  data() {
    return {
      //定义loading默认为false
      logining: false,
      // 记住密码
      rememberpwd: false,
      ruleForm: {
        //username和password默认为空
        username: '',
        password: '',
        // code: '',
        // randomStr: '',
        // codeimg: ''
      },
      //rules前端验证
      rules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        // code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      }
    }
  },
   // 注册组件
  components: {
    particles
  },

  // 创建完毕状态(里面是操作)
  created() {
    // 进入页面就发送请求,将访问的域名传递，后台判断是否是在符合域名集合中
    // 根据域名判断账户,获取账户相关配置
    // window.alert(999)
    // console.log('不加载页面')
    // return false

    // this.$message({
    //   message: '账号密码及验证码不为空即可',
    //   type: 'success'
    // })
    // 获取图形验证码
    // this.getcode()
    // 获取存在本地的用户名密码
    this.getuserpwd()
    
  },
  // 里面的函数只有调用才会执行
  methods: {
    // 获取用户名密码
    getuserpwd() {
      if (getCookie('user') != '' && getCookie('pwd') != '') {
        this.ruleForm.username = getCookie('user')
        this.ruleForm.password = getCookie('pwd')
        this.rememberpwd = true
      }
    },
    //获取info列表
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.logining = true
          const pwd = this.ruleForm.password;
          // 测试通道，不为空直接登录
          // setTimeout(() => {
          //   this.logining = false
          //   this.$store.commit('login', 'true')
          //   this.$router.push({ path: '/goods/Goods' })
          // }, 1000)
          // 注释

          // MD5加密
          this.ruleForm.password = md5(this.ruleForm.password)
          login(this.ruleForm).then(res => {
            if (res.code == 200) {
              if (this.rememberpwd) {
                //保存帐号到cookie，有效期7天
                setCookie('user', this.ruleForm.username, 7)
                //保存密码到cookie，有效期7天
                setCookie('pwd', pwd, 7)
              } else {
                delCookie('user')
                delCookie('pwd')
              }
              //如果请求成功就让他2秒跳转路由
              setTimeout(() => {
                this.logining = false
                // 缓存token
                localStorage.setItem('logintoken', res.data.user.token)
                localStorage.setItem('path',JSON.stringify(res.data.path))
                // 缓存用户个人信息
                localStorage.setItem('userdata', JSON.stringify(res.data.user))
                this.$store.commit('login', 'true')
                if(res.data.user.role_sign == 'park'){
                  this.$router.push({ path: '/console/console01' })
                }else if(res.data.user.role_sign == 'agency'){
                  this.$router.push({ path: '/console/consoleAgency' })
                }else{
                  this.$router.push({ path: '/index/console' })
                }
              }, 1000)
            } else {
              this.$message.error(res.msg)
              this.logining = false
              return false
            }
          })
        } else {
          // 获取图形验证码
          this.getcode()
          this.$message.error('请输入用户名密码！')
          this.logining = false
          return false
        }
      })
    },
  }
}
</script>

<style scoped>
.login-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding-top: 10%;
  /* background-image: url("../assets/img/content_bg.png"); */
  /* background-color: #112346; */
  /* background-color: #1d93a2; */
  background-repeat: no-repeat;
  background-position: center right;
  background-size: 100%;
  z-index: 10;
}
.login-container {
  border-radius: 10px;
  margin: 0px auto;
  width: 350px;
  padding: 30px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  text-align: left;
  box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
  z-index:666;
}
.title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}
.remember {
  margin: 0px 0px 35px 0px;
}
.code-box {
  text-align: right;
}
.codeimg {
  height: 40px;
}
.login_form {
  z-index: 999;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -200px;
  margin-left: -200px;
}
.gongsi_name {
  display: inline-block;
  left: 50%;
  transform: translateX(-50%);
  position: absolute;
  bottom: 25px;
  color: #EDEDED;
  z-index: 998;
  text-align: center;
  letter-spacing: 1px;
  font-size: 12px;
  font-family: "PingFang SC","微软雅黑","宋体",Arial,Helvetica,sans-serif;
}
.code_img {
  position: absolute;
  z-index: 998;
}
.wechat_code {
  display: block;
  width: 120px;
  height: 120px;
  margin: 15px auto;
  margin-top: 15px;
  margin-bottom: 5px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 25px;
}
</style>


// WEBPACK FOOTER //
// src/views/login.vue